import { LandlordFunnelState } from 'scenes/landlord/types';
import { WirePayment } from 'scenes/common/analytics/types';
import {
  getPaymentFrequency,
  getPaymentMethod,
} from 'scenes/landlord/selectors';

export const toWirePayment = (state: LandlordFunnelState): WirePayment => ({
  method: getPaymentMethod(state),
  terms: getPaymentFrequency(state),
});
